// extracted by mini-css-extract-plugin
export var quillEditor = "_oj-1";
export var variable = "_oj-0";